import { render, staticRenderFns } from "./DialogVT.vue?vue&type=template&id=20574572&scoped=true"
import script from "./DialogVT.vue?vue&type=script&lang=js"
export * from "./DialogVT.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20574572",
  null
  
)

export default component.exports